const styles = {
  qrcode: {
    fontSize: 110,
  },
  hideInput: {
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
  },
};

export default styles;
